// extracted by mini-css-extract-plugin
export default {"headline":"style_headline__MlLLf"};